import { inject, Injectable } from '@angular/core';
import { BaseService } from '../../services/base.service';
import { ConfigService } from '../../services/config.service';
import { ActionType } from '../../config/action.config';

@Injectable({ providedIn: 'root' })
export class AuthService extends BaseService {
  private configService = inject(ConfigService);

  ValidarAction(action: ActionType): boolean {
    return (
      this.configService.validActions.indexOf(action) >= 0 &&
      this.actions.indexOf(action) >= 0
    );
  }
}
